import React, { Component } from 'react';
import PropTypes from 'prop-types'

class AnswerOptionComponent extends Component {
  constructor (props){
    super(props)
    this.state={
      currentAnswer: '',
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.questionId !== this.props.questionId) {
      this.setState({currentAnswer: this.props.selectedAnswer})
    }
  }

  render(){
    
    return (
      <div>
        <li className="answerOption">
          <input
            type="radio"
            className="radioCustomButton"
            name="radioGroup"
            checked={this.props.selectedAnswer === this.props.answerType}
            id={this.props.answerType}
            value={this.props.answerType}
            disabled={this.setAnswer}
            onChange={this.props.onAnswerSelected}
          />
          <label className="radioCustomLabel" htmlFor={this.props.answerType}>
            {this.props.answerContent}
          </label>
        </li>
      </div>
    );
  }

}


AnswerOptionComponent.propTypes = {
  answerType: PropTypes.string.isRequired,
  answerContent: PropTypes.string.isRequired,
  onAnswerSelected: PropTypes.func.isRequired,
  selectedAnswer: PropTypes.string.isRequired,
};

export default AnswerOptionComponent;



// WEBPACK FOOTER //
// ./src/components/quiz/AnswerOption.js